import React from "react";
import QuoteForm from "@/components/QuoteForm";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const Contact = () => (
  <div data-testid="contact-page">
    <section className="border-b border-border bg-muted">
      <div className="container-wide py-16 lg:py-20">
        <p className="kicker">Contact · Free Quote</p>
        <h1 className="mt-3 font-display text-4xl font-black sm:text-5xl lg:text-6xl">
          Get a free hauling quote in 60 seconds.
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-muted-foreground">
          Serving Wesley Chapel and the rural back roads of Pasco, Hernando, and Hillsborough counties.
        </p>
      </div>
    </section>

    <section className="section">
      <div className="container-wide grid gap-10 lg:grid-cols-5">
        <div className="lg:col-span-3">
          <QuoteForm />
        </div>
        <div className="lg:col-span-2 space-y-6">
          <div className="rounded-sm border border-border bg-card p-6">
            <p className="kicker">Talk to us</p>
            <h3 className="mt-2 font-display text-xl font-bold">Prefer to call?</h3>
            <p className="mt-2 text-sm text-muted-foreground">
              Tap the number below — we&apos;ll pick up during business hours.
            </p>
            <a
              href="tel:+18135550100"
              className="btn-cta mt-4 w-full"
              data-testid="contact-call-cta"
            >
              <Phone className="h-4 w-4" /> (813) 555-0100
            </a>
          </div>
          <div className="rounded-sm border border-border bg-card p-6">
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Mail className="mt-0.5 h-4 w-4 text-primary" />
                <div>
                  <p className="font-semibold">Email</p>
                  <a href="mailto:info@fastjunkpros.com" className="text-muted-foreground hover:text-foreground">
                    info@fastjunkpros.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 text-primary" />
                <div>
                  <p className="font-semibold">Based in</p>
                  <p className="text-muted-foreground">Wesley Chapel, FL 33544</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="mt-0.5 h-4 w-4 text-primary" />
                <div>
                  <p className="font-semibold">Hours</p>
                  <p className="text-muted-foreground">Mon–Sat · 7am – 7pm ET</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default Contact;
